<template>
  <div class="l-content-inner">
    <div class="c-head">
      <h1 class="head-title">검색결과</h1>
      <BreadCrumb :breadcrumbs="breadcrumbItems" />
    </div>

    <div class="l-content">
      <!-- D: 검색창 영역 -->
      <div class="c-search-result-area">
        <!-- D: PC 전용 -->
        <div class="result-text">
          <p>
            <strong
              v-for="(keyword, index) in searchedKeywords"
              :key="keyword"
              class="color-primary"
            >
              <span v-if="index > 0">, </span>
              ‘{{ keyword }}’
            </strong>
            의 검색결과 입니다.
          </p>
        </div>
        <!-- // D: PC 전용 -->
        <div class="result-search-box">
          <!-- D: PC 전용 -->
          <div class="c-check-field">
            <div class="c-checkbox">
              <input
                type="checkbox"
                :id="reSearchCheckboxId"
                v-model="isResearching"
              />
              <label :for="reSearchCheckboxId">
                <b>결과내 재검색</b>
              </label>
            </div>
          </div>
          <!-- // D: PC 전용 -->
          <!-- D: data-layer-hidden 속성 존재시 단순 검색 케이스로 바뀜 -->
          <SearchKeyword
            v-model:keyword="keyword"
            @keyword-changed="onSearchKeywordChange"
          />
        </div>
      </div>
      <!-- // D: 검색창 영역 -->

      <!-- D: 검색결과 페이지 -->
      <div class="p-search-result-wrap">
        <SearchCategory
          v-if="searchCategories"
          v-model:searchCategories="searchCategories"
          :search-Params="searchParams"
          :is-nodata="isNodata"
          @select-changed="onSearchCategoriesChange"
        />

        <!-- D: total&sorting -->
        <div v-if="!isNodata" class="c-sorting-wrap">
          <em v-if="pageData" class="total">
            총:
            <span class="system">
              {{ Utils.currency(pageData.totalCount) }}
            </span>
            개
          </em>
          <!-- D: pc 전용 -->
          <ul class="sorting c-pc">
            <li class="sorting-item">
              <!-- D: 클릭시 is-current 클래스 추가 -->
              <a
                href="#"
                :class="{
                  'is-current': searchParams.sortOrder === 'recommend',
                }"
                @click.prevent="onSortChange('recommend')"
                >추천순</a
              >
            </li>
            <li class="sorting-item">
              <a
                href="#"
                :class="{ 'is-current': searchParams.sortOrder === 'populate' }"
                @click.prevent="onSortChange('populate')"
                >인기순</a
              >
            </li>
            <li class="sorting-item">
              <a
                href="#"
                :class="{ 'is-current': searchParams.sortOrder === 'register' }"
                @click.prevent="onSortChange('register')"
                >신제품순</a
              >
            </li>
          </ul>
          <!-- D: MO 전용 -->
          <div class="c-select type-medium c-mo">
            <select
              v-model="searchParams.sortOrder"
              @change="onSortChange(searchParams.sortOrder)"
            >
              <option value="recommend">추천순</option>
              <option value="populate">인기순</option>
              <option value="register">신제품순</option>
            </select>
          </div>
        </div>

        <!-- D: product compentnt -->
         <div class="scroll-x only-pc-widh">
            <div class="scroll-x scroll-x-inner">
              <ProductItem
                v-for="(item,index) in list"
                :key="item.matnr"
                :product="item"
                :werks="CODE_WERKS"
                :index="index"
                @updateQuantity="list[index].quantity = $event"
                @buy="(product) => addBuyItem(product)"
                @cart="(product) => addCartItem(product)"
                @plus="plusItem(index)"
                @minus="minusItem(index)"
                @select="openProdInfoPop"
              />
            </div>
          </div>
        <!-- // .c-product-->

        <!-- D: 겸색 결과가 존재하지 않은 경우 노출 -->
        <p
          v-if="isNodata && recommendedList.length > 0"
          class="recommend-title"
        >
          이런 제품은 어떠세요? <br class="only-mo" />
          최근 많이 찾는 제품을 추천드려요.
        </p>
        <div
          v-if="isNodata && recommendedList.length > 0"
          class="c-products col5"
        >
          <ProductItem
            v-for="item in recommendedList"
            :key="item.matnr"
            :product="item"
            @buy="(product) => addBuyItem(product)"
            @cart="(product) => addCartItem(product)"
            @select="openProdInfoPop"
          />
        </div>
        <!-- // D: 겸색 결과가 존재하지 않은 경우 노출 -->
      </div>
    </div>

    <OrderSheet ref="orderSheet" @select="openProdInfoPop" />
    <QuickMenu />
  </div>
  <ProdInfoPop
    v-if="isShowProdInfoPop"
    v-bind="prodInfoPopProps"
    @close="() => (isShowProdInfoPop = false)"
  />
</template>
<script setup name="search">
import {
  onMounted,
  ref,
  inject,
  provide,
  readonly,
  onBeforeUnmount,
  watch,
  nextTick,
} from "vue";
import SearchKeyword from "@/components/paintpro/prod/searchKeyword.vue";
import QuickMenu from "@/components/paintpro/quickMenu/quickMenu.vue";
import BreadCrumb from "@/components/paintpro/base/breadCrumb.vue";
import { api } from "@/plugins/api";
import SearchCategory from "@/components/paintpro/prod/searchCategory.vue";
import ProductItem from "@/components/paintpro/prod/searchProductItemSub.vue";
import ProdInfoPop from "@/components/paintpro/prod/prodInfoPop.vue";
import OrderSheet from "@/components/paintpro/prod/orderSheet.vue";
import Utils from "@/js/utils";
import * as cmUtil from "@/utils/cmUtil";
import * as cmApi from "@/api/cmApi";
import { v4 as uuidv4 } from "uuid";
import { computed } from "vue";
import * as store from "@/store";
import { useAuthStore } from "@/store";
import { useRoute } from "vue-router";

const authStore = useAuthStore();
const url = inject("url_prefix");

const keyword = ref(useRoute().query.keyword);
const searchCategories = ref(null);

const breadcrumbItems = ref([{ name: "검색결과", path: "/paintpro/search" }]);

const reSearchCheckboxId = uuidv4();
const isResearching = ref(false);

const CODE_WERKS = ref([]);
provide("CODE_WERKS", readonly(CODE_WERKS));

const CODE_GOODS_FILE_SE_CD = ref([]);
provide("CODE_GOODS_FILE_SE_CD", readonly(CODE_GOODS_FILE_SE_CD));

const searchParams = ref({
  keyword: useRoute().query.keyword,
  prevKeywords: [],
  lvl2Categories: [],
  lvl3Categories: [],
  lvl4Categories: [],
  //totalQtyCategories: [],
  //setgdYnCategories: [],

  matkl: "", // 영업사원 담당분야

  page: 1,
  limit: 20,

  sortOrder: "recommend", // recommend: 추천순, populate:인기순, register:신제품순
});
const pageData = ref(null);
const list = ref([]);

const recommendedList = ref([]);

const isShowProdInfoPop = ref(false);
const prodInfoPopProps = ref({
  matnr: null,
});

const scrollSensed = ref(false); // 스크롤 중복 감지를 막기 위한 변수입니다.

const isNodata = ref(false);

const onLoadSearchDataYn = ref(false);

//const loadSearchDataYn = ref(false);

onMounted(() => {
  initPage();

  loadSearchCategories();
  loadSearchData();

  window.addEventListener("scroll", onScrollEvent, true);
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", onScrollEvent);
});

const salesBranch = computed(() => {
  return authStore.user?.empList[store.useEventBusStore()?.salesPersonIndex];
});

watch(salesBranch, () => {
  loadRecommendedProductList();

  resetPage();
  loadSearchData();
});

const searchedKeywords = computed(() => {
  return [searchParams.value.keyword, ...searchParams.value.prevKeywords];
});

const initPage = async () => {
  const res = await cmApi.getPageInitData([
    { qId: "cmCode_code1", parm: { cdGrp: "WERKS" } },
    { qId: "cmCode_code2", parm: { cdGrp: "GOODS_FILE_SE_CD" } },
  ]);

  const { resultCode } = res;
  if (resultCode !== 200) {
    return false;
  }
  CODE_WERKS.value = res.data.cmCode_code1;
  CODE_GOODS_FILE_SE_CD.value = res.data.cmCode_code2;
};

const loadSearchCategories = async () => {

  const res = await api.post(`${url}/product/search-categories`, {
    keyword: searchParams.value.keyword,
    prevKeywords: searchParams.value.prevKeywords,
    clsfCdListLvl2 : searchParams.value.lvl2Categories,
    clsfCdListLvl3 : searchParams.value.lvl3Categories
  });

  const { resultCode } = res;
  if (resultCode !== 200) {
    return;
  }

  if(searchCategories.value==null){
    searchCategories.value = res.data;
  }else{
    console.log("데이터 변경");
    searchCategories.value.lvl2Categories = res.data.lvl2Categories;
    searchCategories.value.lvl3Categories = res.data.lvl3Categories;
    searchCategories.value.lvl4Categories = res.data.lvl4Categories;
  }

  for(var lvl2i=0; lvl2i<searchParams.value.lvl2Categories.length; lvl2i++){
    for(var lvl2ii=0; lvl2ii<searchCategories.value.lvl2Categories.length; lvl2ii++){
      if(searchParams.value.lvl2Categories[lvl2i] == searchCategories.value.lvl2Categories[lvl2ii].clsfCd){
        searchCategories.value.lvl2Categories[lvl2ii].selected = true;
      }
    }    
  }

  for(var lvl3i=0; lvl3i<searchParams.value.lvl3Categories.length; lvl3i++){
    for(var lvl3ii=0; lvl3ii<searchCategories.value.lvl3Categories.length; lvl3ii++){
      if(searchParams.value.lvl3Categories[lvl3i] == searchCategories.value.lvl3Categories[lvl3ii].clsfCd){
        searchCategories.value.lvl3Categories[lvl3ii].selected = true;
      }
    }    
  }

  for(var lvl4i=0; lvl4i<searchParams.value.lvl4Categories.length; lvl4i++){
    for(var lvl4ii=0; lvl4ii<searchCategories.value.lvl4Categories.length; lvl4ii++){
      if(searchParams.value.lvl4Categories[lvl4i] == searchCategories.value.lvl4Categories[lvl4ii].clsfCd){
        searchCategories.value.lvl4Categories[lvl4ii].selected = true;
      }
    }    
  }
};


const loadSearchData = async () => {
  if (onLoadSearchDataYn.value) return;

  onLoadSearchDataYn.value = true;

  if (!authStore.user) return;

  searchParams.value.matkl = salesBranch.value?.matkl; // 현재 선택된 영업사원 담당분야

  const res = await api.post(`${url}/product/search`, {
    ...searchParams.value,
  });

  const { resultCode } = res;
  if (resultCode !== 200) {
    return;
  }

  cmUtil.loadingHide();

  pageData.value = res.data;
  list.value.push(...pageData.value.list);
  list.value = list.value.map(item => ({...item,quantity:1}));

  isNodata.value = list.value.length === 0;

  onLoadSearchDataYn.value = false;
};


const resetPage = () => {
  searchParams.value.page = 1;
  list.value = []; // 리스트 초기화
};

const onSearchKeywordChange = async () => {
  if (Utils.isBlank(keyword.value)) {
    await cmUtil.alert("검색어를 입력하세요.");
    return;
  }
  // 재검색 여부
  if (isResearching.value && Utils.isNotBlank(searchParams.value.keyword)) {
    searchParams.value.prevKeywords.push(searchParams.value.keyword);
  } else {
    searchParams.value.prevKeywords = [];
  }

  searchParams.value.keyword = keyword.value.trim();

  resetPage();

  loadSearchData();
  loadSearchCategories();
};

const onSearchCategoriesChange = async () => {
  if (!searchCategories.value) {
    searchParams.value.lvl2Categories = [];
    searchParams.value.lvl3Categories = [];
    searchParams.value.lvl4Categories = [];
    //searchParams.value.totalQtyCategories = [];
    //searchParams.value.setgdYnCategories = [];

    return;
  }

  searchParams.value.lvl2Categories = searchCategories.value.lvl2Categories
    .filter((item) => item.selected === true)
    .map((item) => item.clsfCd);

  searchParams.value.lvl3Categories = searchCategories.value.lvl3Categories
    .filter((item) => item.selected === true)
    .map((item) => item.clsfCd);

  searchParams.value.lvl4Categories = searchCategories.value.lvl4Categories
    .filter((item) => item.selected === true)
    .map((item) => item.clsfCd);

  // searchParams.value.totalQtyCategories =
  //   searchCategories.value.totalQtyCategories
  //     .filter((item) => item.selected === true)
  //     .map((item) => item.clsfCd);

  // searchParams.value.setgdYnCategories =
  //   searchCategories.value.setgdYnCategories
  //     .filter((item) => item.selected === true)
  //     .map((item) => item.clsfCd);

  cmUtil.loading("", { duration: 60000 });
  
  loadSearchCategories();

  await resetPage();

  nextTick(() => {
    loadSearchData();
  });
};

const onSortChange = (sortOrder) => {
  searchParams.value.sortOrder = sortOrder;
  resetPage();

  loadSearchData();
};

const loadNextPage = () => {
  if (!pageData.value) {
    // 페이지 정보가 로드되지 않은 상태에서는 다음페이지를 로드하지 않습니다.
    return;
  }

  if (pageData.value.currPage >= pageData.value.totalPage) {
    return;
  }

  searchParams.value.page += 1;

  loadSearchData();
};

const openProdInfoPop = (product) => {
  prodInfoPopProps.value.matnr = product.matnr;
  isShowProdInfoPop.value = true;
};

const loadRecommendedProductList = async () => {
  if (!salesBranch.value) {
    return;
  }

  const res = await api.get(
    `${url}/product/matkl/${salesBranch.value.matkl}/recommended-product-list`
  );

  recommendedList.value = res.data;
};

const onScrollEvent = () => {
  const scrollTop = Math.ceil(document.documentElement.scrollTop);
  const scrollHeight = document.documentElement.scrollHeight;
  const clientHeight = document.documentElement.clientHeight;

  const isBottom = scrollTop + clientHeight >= scrollHeight ? true : false;

  if (isBottom) {
    loadNextPage();

    scrollSensed.value = true;
    setTimeout(() => {
      scrollSensed.value = false;
    }, 50);
    scrollSensed.value = true;
  }
};

const addBuyItem  = async (param = { product: null, quantity: 0 }) => {
  orderSheet.value.addItemList(param);
};
provide("addBuyItem", addBuyItem);

const addCartItem = async (param = { product: null, quantity: 0 }) => {
  await cmApi.insertUserBasketProd({
    goodsSn: param.product.goodsSn,
    zzlqdCls: param.product.zzlqdCls,
    goodsQty: param.product.quantity,
  });
};
provide("addCartItem", addCartItem);


const orderSheet = ref();


const plusItem = (index) => {
  list.value[index].quantity = Number(list.value[index].quantity) + 1;
};
provide("plusItem", plusItem);

const minusItem = (index) => {
  if(Number(list.value[index].quantity) > 1){
    list.value[index].quantity = Number(list.value[index].quantity) - 1;
  }
};
provide("minusItem", minusItem);

</script>